export default __webpack_public_path__ + "static/media/ellipse.6992fc74.svg";